import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AjaxFetchService from 'garaje/services/ajax-fetch';
import urlBuilder from 'garaje/utils/url-builder';

interface NearestInviteResponse {
  data: {
    id: string;
  };
}

interface VisitorsRecurringInviteSeriesNearestParams {
  id: string;
}

export default class VisitorsRecurringInviteSeriesNearestRoute extends Route {
  @service declare ajaxFetch: AjaxFetchService;
  @service declare router: RouterService;

  async model(params: VisitorsRecurringInviteSeriesNearestParams): Promise<void> {
    const response = await this.ajaxFetch.request<NearestInviteResponse>(
      urlBuilder.v3.recurringInviteSeries.nearestInvite(params.id),
    );

    void this.router.replaceWith('visitors.invites.show', response.data.id);
  }
}
